import { ModalInjectedProps } from '@sketch/components'
import {
  WorkspaceMinimalFragment,
  ProjectFragment,
  useGetProjectQuery,
} from '@sketch/gql-types'
import React from 'react'
import {
  ConfirmStorageItemTransferModalProps,
  ConfirmStorageItemTransferModal,
} from '../../../storageItems/modals/ConfirmStorageItemTransferModal'
import { useTransfer } from './ProjectListItem.hooks'

interface ConfirmStorageItemTransferModalDraggedProps
  extends Pick<ConfirmStorageItemTransferModalProps, 'item' | 'hideModal'>,
    ModalInjectedProps {
  workspace: WorkspaceMinimalFragment
  destinationProject: ProjectFragment
}

export const ConfirmStorageItemTransferModalDragged = (
  props: ConfirmStorageItemTransferModalDraggedProps
) => {
  const { item, destinationProject, workspace, hideModal, ...rest } = props

  const { move, loading } = useTransfer({
    workspaceId: workspace.identifier,
    newProject: destinationProject,
  })

  const currentProjectId = (
    item.__typename === 'Project' ? item.topLevelProject : item.project
  )?.identifier

  // we are expecting to receive this project from a cache
  const currentProjectQuery = useGetProjectQuery({
    variables: { shortId: currentProjectId || '' },
    skip: !currentProjectId,
  })

  return (
    <ConfirmStorageItemTransferModal
      {...rest}
      loading={loading || currentProjectQuery.loading}
      onCancel={props.hideModal}
      hideModal={hideModal}
      onConfirm={async () => {
        await move(item)
        hideModal()
      }}
      item={item}
      destination={{
        // We are allowing to drag&drop storage items within the same workspace
        workspace,
        project: destinationProject,
      }}
      currentLocation={{
        workspace,
        project: currentProjectQuery.data?.project || null,
      }}
    />
  )
}
